module.exports = "<label class=nn-base-checkbox><span class=nn-base-checkbox__control><input ng-change=onChange(ngModel) ng-model=ngModel type=checkbox> <span class=control__ico></span></span><div ng-transclude></div></label>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-checkbox/nn-base-checkbox.directive.html
// module id = 952
// module chunks = 0